import { ArrowRight } from "lucide-react";
import { CONTACT } from "@/data/content";
import { MessengerRow, PhoneLink } from "./ContactButtons";

export const ContactCTA = () => (
  <section id="contact" className="relative overflow-hidden border-t border-white/5 bg-[#0a0a0a] py-24">
    <div className="absolute -right-20 top-1/2 h-[500px] w-[500px] -translate-y-1/2 rounded-full bg-[#B12A2A]/10 blur-[120px]" />
    <div className="container relative z-10 mx-auto px-4 text-center sm:px-6 lg:px-8">
      <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#B12A2A]">
        Безкоштовна консультація
      </span>
      <h2 className="mx-auto mt-4 max-w-3xl font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        Розкажіть, яке авто шукаєте — підберу найкращий варіант під ваш бюджет
      </h2>
      <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg">
        Напишіть у зручний месенджер або зателефонуйте. Консультація безкоштовна та ні до чого не зобов'язує.
      </p>

      <div className="mt-10 flex flex-col items-center justify-center gap-5 sm:flex-row">
        <a
          href={CONTACT.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-whatsapp-button"
          className="group inline-flex items-center justify-center gap-2 rounded-md bg-[#B12A2A] px-8 py-4 text-base font-semibold text-white transition-colors hover:bg-[#C73D3A]"
        >
          Написати у WhatsApp
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </a>
        <PhoneLink className="text-lg text-white" />
      </div>

      <div className="mt-10 flex justify-center">
        <MessengerRow />
      </div>
    </div>
  </section>
);
